/* eslint-disable react/jsx-sort-props */
/*eslint import/no-cycle: [2, { maxDepth: 1 }]*/
import React from 'react';
import { usePageTitle } from '../../config';
import { styled } from '@mui/material/styles';
import '../../../node_modules/@okta/okta-signin-widget/dist/css/okta-sign-in.min.css';
import { useLocalizationContext, useTranslate } from '@im/react-localization';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import { LoginWidget } from '../../auth/okta-widget-customizations/LoginWidget';
import { SxProps, useTheme, Theme } from '@mui/system';

export const LoginViewX4EC = () => {
  const translateStr = useTranslate();
  const copyrightContent = translateStr('OktaWidget.Copyright');
  const whatYearIsItNow = new Date().getFullYear().toString();
  const { updatePageTitle } = usePageTitle();
  const l10nContext = useLocalizationContext();
  const { locale } = l10nContext;
  const [, countryCode] = locale.split('-');

  const contactUsURLs = {
    // NL: `/cep/app/cms/nl-nl/general/contact-us`,
  };

  const isCountryCode = (code: string): code is keyof typeof contactUsURLs => {
    return code in contactUsURLs;
  };

  const openContactUsNewTab = (countryCode: string) => {
    if (isCountryCode(countryCode)) {
      (window as any).open(contactUsURLs[countryCode], '_blank');
    } else {
      console.error(
        'Invalid country code or missing URL for the provided country code.'
      );
    }
  };

  // updatePageTitle(translateStr('Title.Login'));
  updatePageTitle('Login');

  document.getElementById('loaderDiv')?.remove();
  const theme = useTheme() as Theme;
  const themeTypography = (theme.typography || {}) as {
    [key: string]: SxProps<Theme>;
  };

  return (
    <Root columnSpacing={8} container>
      <Grid
        alignItems="center"
        border="1px soild cyan"
        display="flex"
        flexDirection="column"
        item
        justifyContent="space-between"
        xs={12}
        md={6}
        sx={{
          pb: 8,
          pt: 8,
        }}
      >
        <Box height={36} width="100%">
          Logo
        </Box>
        <Box flex={1}>
          <Typography
            sx={{
              ...themeTypography['display-sm-semibold'],
            }}
          >
            Welcome back
          </Typography>
          <LoginWidget />
        </Box>
        <Box
          sx={{
            alignContent: 'center',
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'center',
            width: '100%',
          }}
        >
          <Typography
            align="center"
            color={(theme) => theme.palette.text.secondary}
            padding={3}
            variant="body2"
          >
            {copyrightContent.replace(/\{\{year\}\}/gi, whatYearIsItNow)}
          </Typography>
          {countryCode &&
            (countryCode.toUpperCase() === 'BE' ||
              countryCode.toUpperCase() === 'NL') && (
              <Button
                onClick={() => openContactUsNewTab(countryCode)}
                size="medium"
                sx={{
                  borderColor: '#C4C4C4 !important',
                  fontSize: '14px',
                  marginTop: 2,
                }}
                variant="outlined"
              >
                Contact us
                {/* {translateStr('Login.Contact_us')} */}
              </Button>
            )}
        </Box>
      </Grid>

      <Grid
        item
        xs={0}
        md={6}
        sx={{
          pb: 4,
          pt: 4,
        }}
      >
        <Box
          sx={{
            background: 'linear-gradient(45deg, #194185 0%, #1570EF 100%)',
            borderRadius: '20px',
            height: '100%',
            width: '100%',
          }}
        />
      </Grid>
      {/* {window.isOneTrustEnabled && (
        <style>{`#onetrust-banner-sdk.otFlat {left:28px !important}`}</style>
      )} */}
    </Root>
  );
};

const Root = styled(Grid)(({ theme }) => ({
  '#okta-sign-in .auth-header': {
    padding: '0',
  },
  '#okta-sign-in .beacon-container': {
    bottom: 30,
  },
  '#okta-sign-in.auth-container': {
    '.mfa-google-auth,.mfa-google-auth-30': {
      // backgroundImage:
      // 'url(/cep/assets/okta-signin-widget/img/icons/mfa/google-ms-authenticators_sm.png)',
      backgroundSize: 'contain',
    },
  },
  '#okta-sign-in.auth-container.main-container': {
    '.auth-content': {
      padding: 'unset',
    },
    '.button-primary': {
      background: theme.palette.primary.main,
      borderColor: theme.palette.primary.main,
      borderRadius: 6,
      color: theme.palette.common.white,
      fontSize: 18,
      height: 56,
    },
    '.link': {
      color: theme.palette.text.primary,
      fontSize: 14,
    },
    '.o-form .infobox': {
      color: theme.palette.text.secondary,
    },
    '.o-form .input-fix': {
      border: 'unset',
      height: 52,
      input: {
        '&:-webkit-autofill': {
          WebkitBoxShadow: `0 0 0 25px ${theme.palette.common.white} inset`,
          WebkitTextFillColor: theme.palette.text.primary,
          borderRadius: 6,
        },
        '&::selection': {
          //backgroundColor: theme.palette.common.black,
        },
        border: `1px solid ${theme.palette.text.secondary}`,
        borderRadius: 6,
      },
    },
    '.o-form-explain': {
      color: 'unset',
      textAlign: 'left',
    },
    '.o-form-fieldset': {
      '&:first-of-type': {
        marginBottom: 40,
      },
    },
    '.o-form-head': {
      color: theme.palette.text.primary,
      fontSize: 16,
      fontWeight: 400,
      lineHeight: '18.75px',
      textAlign: 'left',
    },
    '.okta-form-input-field': {
      backgroundColor: 'unset',
      boxShadow: 'unset',
    },
    '.okta-form-label': {
      backgroundColor: theme.palette.grey[100],
      fontWeight: 400,
      left: 16,
      padding: '0 4px',
      position: 'relative',
      top: 10,
      width: 'auto',
      zIndex: 1,
    },
    '.okta-sign-in-header.auth-header': {
      '.beacon-container.beacon-small': {
        display: 'none',
      },
      borderBottom: 'unset',
    },

    backgroundColor: 'transparent',
    borderColor: 'transparent',
    boxShadow: 'none',
    color: theme.palette.text.primary,
    fontFamily: 'Inter',
    // height: '100vh',
    input: {
      backgroundColor: theme.palette.common.white,
      color: theme.palette.text.primary,
      fontFamily: 'unset',
    },
    margin: '0',
    overflow: 'unset',
    width: 360,
  },
  '#okta-sign-in.no-beacon .auth-header': {
    paddingBottom: 'unset',
  },
}));
